import React from 'react';
import FormCard from 'Components/Common/FormCard';
import ItmFlagsTable from 'Feature/Claims/components/Details/ITMFlagsTable';
import ClaimsIndicatorDetailsFields from 'Feature/Claims/components/IndicatorDetailsFields';
import { ButtonType } from 'Feature/CommonComponents/UserControls';
import { FeatureFlags } from 'Feature/Enums/FeatureFlag.enum';
import { GlossaryNames } from 'Feature/PageComponents/components/GlossaryComponent/types';
import { useFeature } from 'flagged';
import { useHBTFormContext } from '../../HBTFormContext';
import ClaimsIndicatorDetailsAdjudicationProps from './types';

const ClaimsIndicatorDetailsAdjudication = ({
  fields
}: ClaimsIndicatorDetailsAdjudicationProps) => {
  const siteTypeIsInternal = useFeature(FeatureFlags.INTERNAL);
  const { isFieldDisabled } = useHBTFormContext();
  return (
    <>
      {siteTypeIsInternal && (
        <FormCard
          title={fields.cardTitle}
          headingLevel={2}
          sectionId="claims-indicator-details-body"
          fieldToValidate="indicator"
          toolTipButton={{
            id: 'indicatorDetailsGlossaryTooltip',
            name: 'indicatorDetailsGlossaryTooltip',
            ariaText: fields.cardGlossaryAriaText?.value ?? '',
            onClick: () => {
              fields?.openGlossary?.(GlossaryNames.IndicatorDetails);
            },
            buttonType: ButtonType.TEXT
          }}
        >
          <ClaimsIndicatorDetailsFields fields={fields} />
          <ItmFlagsTable fields={fields} />
        </FormCard>
      )}
    </>
  );
};

export default ClaimsIndicatorDetailsAdjudication;
